import React from 'react';
import { FormattedNumber } from 'react-intl';
import CalcItem from './CalcItem';
import styled from 'styled-components';

const Calc = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px;
`;

const CalcRow = styled.div`
  flex: 1;
  flex-direction: row;
  display: flex;
`;

const formattedNumberProps = {
  style: 'currency', currency: 'CZK',
};

const NumPad = ({ total, paid, calcButtonPressed }) => {
  return (
    <Calc>
      <table>
        <tbody>
        <tr>
          <td style={{ textAlign: 'left', fontWeight: 'bold' }}>Celkem</td>
          <td style={{ textAlign: 'right', fontSize: '1.2em' }}>
            <FormattedNumber value={total || 0} {...formattedNumberProps} />
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: 'left', fontWeight: 'bold' }}>Zaplaceno</td>
          <td style={{ textAlign: 'right', fontSize: '1.2em'  }}>
            <FormattedNumber value={paid || 0} {...formattedNumberProps} />
          </td>
        </tr>
        <tr>
          <td style={{ textAlign: 'left', fontWeight: 'bold' }}>Vrátit</td>
          <td style={{ textAlign: 'right', fontSize: '1.2em'  }}>
            <FormattedNumber value={paid - total || 0} {...formattedNumberProps} />
          </td>
        </tr>
        </tbody>
      </table>
      <CalcRow>
        <CalcItem value={7} onClick={calcButtonPressed} />
        <CalcItem value={8} onClick={calcButtonPressed} />
        <CalcItem value={9} onClick={calcButtonPressed} />
      </CalcRow>
      <CalcRow>
        <CalcItem value={4} onClick={calcButtonPressed} />
        <CalcItem value={5} onClick={calcButtonPressed} />
        <CalcItem value={6} onClick={calcButtonPressed} />
      </CalcRow>
      <CalcRow>
        <CalcItem value={1} onClick={calcButtonPressed} />
        <CalcItem value={2} onClick={calcButtonPressed} />
        <CalcItem value={3} onClick={calcButtonPressed} />
      </CalcRow>
      <CalcRow>
        <CalcItem value={'X'} onClick={calcButtonPressed} />
        <CalcItem value={0} onClick={calcButtonPressed} />
        <CalcItem value={'<'} onClick={calcButtonPressed} />
      </CalcRow>
    </Calc>
  );
};

export default NumPad;
